import _ from 'lodash';
import { localizationData } from '../../Intl/setup';

export function translate(key) {
  if (!localizationData.en) {
    return key;
  }

  const found = localizationData.en.messages[key];
  if (found) {
    return found;
  }

  return key;
}

export default {
  translate
};
